import { DisabledCodeFragment } from 'graphql/fragments/blockedDates/generated/disabledCodeFragment';
import { BlockedDatesConfigDocument } from 'graphql/queries/blockedDate/generated/BlockedDatesConfig';

export const getRefetchQueries = () => [{ query: BlockedDatesConfigDocument }];

export const disabledCodesToJSON = ({ targetGroup, tourTopic }: DisabledCodeFragment) =>
  JSON.stringify({ tourTopicId: tourTopic.id, targetGroupId: targetGroup.id });
